// @flow
import { FETCH_PASSBOOK, FETCH_PASSBOOK_SUCCESS, FETCH_PASSBOOK_ERROR } from './types';
import type { Action } from "./types";

export const fetchPassbook = (mobile: string, startDate: string, endDate: string, firstFetch: boolean): Action => ({
  type: FETCH_PASSBOOK,
  payload: {mobile, startDate, endDate, firstFetch}
});

export const fetchPassbookSuccess = (passbook: Array<any>): Action => ({
  type: FETCH_PASSBOOK_SUCCESS,
  payload: passbook
});

export const fetchPassbookError = (error: Error): Action => ({
  type: FETCH_PASSBOOK_ERROR,
  payload: error
});